/* =========================================================================
   MANÁ — TEMA "MANHÃS"
   JavaScript próprio do tema. Sem biblioteca externa, sem CDN de terceiro.
   Nada aqui bloqueia a renderização: o arquivo entra com defer.
   ========================================================================= */
(function () {
  'use strict';

  var MESES = ['janeiro','fevereiro','março','abril','maio','junho',
               'julho','agosto','setembro','outubro','novembro','dezembro'];

  /* ---------------------------------------------------------------
     Galeria. Troca a foto grande sem recarregar nada.
     --------------------------------------------------------------- */
  function galeria() {
    var principal = document.getElementById('galeria-principal');
    var tiras = document.querySelectorAll('.tira');
    if (!principal || !tiras.length) return;

    tiras.forEach(function (tira) {
      tira.addEventListener('click', function () {
        var full = tira.getAttribute('data-full');
        var alt = tira.getAttribute('data-alt') || '';
        if (!full) return;
        principal.src = full;
        principal.alt = alt;
        principal.removeAttribute('srcset');
        tiras.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        tira.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------------------------------------------------------------
     Seletor de compra.
     Regra da mesa: a assinatura mostra DATA, não frequência.
     "cobra mensalmente" é aviso; "cobra em 20 de setembro" é compromisso.
     --------------------------------------------------------------- */
  function seletor() {
    var radios = document.querySelectorAll('.seletor input[type="radio"]');
    var botao = document.getElementById('botao-compra');
    var linha = document.getElementById('linha-cobranca');
    var barraPreco = document.getElementById('barra-preco');
    var barraBotao = document.getElementById('barra-botao');
    var naos = document.querySelector('[data-so-assinatura]');
    if (!radios.length) return;

    function dataFutura(dias) {
      var d = new Date();
      d.setDate(d.getDate() + dias);
      return d.getDate() + ' de ' + MESES[d.getMonth()];
    }

    function pintar() {
      var marcado = document.querySelector('.seletor input[type="radio"]:checked');
      if (!marcado) return;

      document.querySelectorAll('.opcao').forEach(function (op) {
        var r = op.querySelector('input[type="radio"]');
        op.classList.toggle('opcao--ativa', !!r && r.checked);
      });

      var preco = marcado.getAttribute('data-preco') || '';
      var cta = marcado.getAttribute('data-cta') || 'Adicionar ao carrinho';
      var recorrente = marcado.getAttribute('data-recorrente') === 'true';
      var ciclo = parseInt(marcado.getAttribute('data-ciclo'), 10) || 0;
      var rotulo = '';
      var nome = marcado.closest('.opcao');
      if (nome) {
        var el = nome.querySelector('.opcao__nome');
        if (el) rotulo = el.textContent.trim();
      }

      if (botao) botao.textContent = cta;
      if (barraBotao) barraBotao.textContent = recorrente ? 'Assinar' : 'Comprar';
      if (barraPreco) barraPreco.textContent = rotulo + ' · ' + preco;

      if (linha) {
        if (recorrente && ciclo > 0) {
          linha.textContent =
            'Próxima cobrança em ' + dataFutura(ciclo) +
            '. A gente avisa três dias antes, com botão de pular dentro do aviso.';
        } else {
          linha.textContent = 'Cobrança única. Nada se repete.';
        }
      }

      if (naos) naos.hidden = !recorrente;
    }

    radios.forEach(function (r) { r.addEventListener('change', pintar); });
    pintar();
  }

  /* ---------------------------------------------------------------
     Barra fixa de compra.
     Aparece quando o botão da dobra sai da tela e some quando ele volta,
     para não existirem dois botões de compra visíveis ao mesmo tempo.
     --------------------------------------------------------------- */
  function barra() {
    var barraEl = document.getElementById('barra-compra');
    var alvo = document.getElementById('botao-compra');
    if (!barraEl || !alvo || !('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        barraEl.setAttribute('data-visivel', e.isIntersecting ? 'false' : 'true');
      });
    }, { rootMargin: '0px 0px -60px 0px' });

    obs.observe(alvo);
  }

  /* ---------------------------------------------------------------
     Cabeçalho: a gaveta do celular e o hambúrguer que vira X.
     --------------------------------------------------------------- */
  function cabecalho() {
    var bt = document.querySelector('.cab__hamburguer');
    var gaveta = document.getElementById('cab-gaveta');
    if (!bt || !gaveta) return;
    bt.addEventListener('click', function () {
      var aberto = bt.getAttribute('aria-expanded') === 'true';
      bt.setAttribute('aria-expanded', String(!aberto));
      bt.setAttribute('aria-label', aberto ? 'Abrir menu' : 'Fechar menu');
      gaveta.hidden = aberto;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && bt.getAttribute('aria-expanded') === 'true') {
        bt.click(); bt.focus();
      }
    });
  }

  /* ---------------------------------------------------------------
     Entrada por rolagem. Um gesto só, escalonado entre irmãos.
     --------------------------------------------------------------- */
  function entrada() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var alvos = document.querySelectorAll('[data-entra]');
    if (!alvos.length) return;
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e, i) {
        if (!e.isIntersecting) return;
        var atraso = (parseInt(e.target.getAttribute('data-entra'), 10) || 0) * 60;
        setTimeout(function () { e.target.classList.add('visivel'); }, atraso);
        obs.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    alvos.forEach(function (a) { obs.observe(a); });
  }

  function iniciar() { galeria(); seletor(); barra(); cabecalho(); entrada(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();

/* ── P13 · O "+" DAS OFERTAS DO CARRINHO ───────────────────────────────────
   Adiciona o produto sem sair do carrinho.

   Este codigo mora aqui, e nao dentro do snippet, por um motivo especifico: o
   snippet e' renderizado DENTRO do <cart-drawer>, e o drawer se redesenha
   chamando `renderContents()`, que troca o HTML por innerHTML. Script inserido
   via innerHTML nao executa — entao o ouvinte nunca era registrado e o "+" nao
   fazia nada. Aqui o arquivo carrega uma vez, no <head>, e o ouvinte delegado no
   document sobrevive a todos os redesenhos do drawer. */
(function () {
  if (window.__cmoLigado) return;
  window.__cmoLigado = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cmo-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var id = btn.getAttribute('data-cmo-add');
    var drawer = document.querySelector('cart-drawer');
    btn.disabled = true;
    btn.classList.add('esta-carregando');

    var fd = new FormData();
    fd.set('id', id);
    fd.set('quantity', 1);
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
    }

    fetch('/cart/add.js', {
      method: 'POST', body: fd, credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (resp.status) throw new Error(resp.description || 'erro');
        /* item ja adicionado: se o redesenho falhar, recarrega em vez de fingir
           que nada aconteceu. */
        try {
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(resp);
            drawer.classList.remove('is-empty');
          } else {
            window.location.reload();
          }
        } catch (err) {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('esta-carregando');
      });
  });
})();

/* ── P13 · O BOTAO "ASSINAR" DA FAIXA DO CARRINHO ──────────────────────────
   Troca a variante de compra unica pela de assinatura sem sair do carrinho.

   O Shopify nao tem "trocar variante" numa chamada so'. `/cart/change.js` mexe
   em quantidade, nao em variante. O caminho e' `/cart/update.js`, que aceita
   varias mudancas de uma vez: zera a variante avulsa e sobe a de assinatura na
   mesma requisicao — atomico, sem o carrinho passar por um estado vazio no meio. */
(function () {
  if (window.__cmoAssinarLigado) return;
  window.__cmoAssinarLigado = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cmo-assinar]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var entra = btn.getAttribute('data-cmo-assinar');
    var sai   = btn.getAttribute('data-cmo-trocar');
    var qtd   = parseInt(btn.getAttribute('data-cmo-qtd'), 10) || 1;
    var drawer = document.querySelector('cart-drawer');

    btn.disabled = true;
    btn.classList.add('esta-carregando');

    var updates = {};
    updates[sai] = 0;
    updates[entra] = qtd;

    var corpo = { updates: updates };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      corpo.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      corpo.sections_url = window.location.pathname;
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify(corpo)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('rede');
        return r.json();
      })
      .then(function (resp) {
        /* A troca ja aconteceu no servidor a esta altura. Se o redesenho falhar
           por qualquer motivo, recarregar e' obrigatorio: sem isso o carrinho
           esta trocado e a tela mostra o estado velho — que e' exatamente o
           "cliquei e nao aconteceu nada". Falhar em silencio aqui e' pior do que
           recarregar a pagina. */
        try {
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(resp);
            drawer.classList.remove('is-empty');
          } else {
            window.location.reload();
          }
        } catch (err) {
          window.location.reload();
        }
      })
      .catch(function () {
        /* Aqui a troca NAO aconteceu: o botao volta a funcionar. */
        btn.disabled = false;
        btn.classList.remove('esta-carregando');
      });
  });
})();

/* ── P14 · OS CARDS DE PRODUTO ─────────────────────────────────────────────
   Tres acoes, como o Luan pediu:
     COMPRAR  → adiciona a variante de COMPRA UNICA escolhida no seletor
     ASSINAR  → adiciona a variante de ASSINATURA
     SABER MAIS → link para a PDP (isso e' <a>, nao precisa de JS)

   O seletor de tamanho troca preco, preco por dose e o alvo do botao comprar.
   O preco por dose e' calculado: preco ÷ (doses da unidade × quantas unidades o
   titulo da variante diz). Se o titulo nao disser um numero, a linha some em vez
   de mostrar conta errada — a regra da casa e' que numero que nao se confere nao
   entra na pagina.

   Ouvinte delegado no document, como o resto: o drawer redesenha por innerHTML e
   qualquer listener preso ao elemento morreria no primeiro add. */
(function () {
  if (window.__pcLigado) return;
  window.__pcLigado = true;

  var fmt = (window.Shopify && Shopify.formatMoney)
    ? function (c) { return Shopify.formatMoney(c, '{{amount_with_comma_separator}}'); }
    : function (c) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ','); };

  /* quantas unidades a variante traz: "2 potes + Caneca" → 2, "1 caixa" → 1 */
  function unidades(titulo) {
    var m = (titulo || '').match(/(\d+)\s*(pote|lata|caixa|display|sach)/i);
    return m ? parseInt(m[1], 10) : 1;
  }

  function atualizaDose(card, precoCentavos, tituloVar) {
    var alvo = card.querySelector('[data-pc-dose]');
    if (!alvo) return;
    var doses = parseInt(card.getAttribute('data-pc-doses') || '0', 10);
    var uni = card.getAttribute('data-pc-unidade') || 'dose';
    var n = unidades(tituloVar) * doses;
    if (!n || !precoCentavos) { alvo.textContent = ''; return; }
    alvo.textContent = fmt(Math.round(precoCentavos / n)) + ' / ' + uni;
  }

  /* estado inicial: a linha de dose so' existe depois deste calculo */
  function iniciar() {
    document.querySelectorAll('[data-pc-card]').forEach(function (card) {
      var marcado = card.querySelector('.pc-var[aria-checked="true"]');
      var precoEl = card.querySelector('[data-pc-preco]');
      if (marcado) {
        atualizaDose(card, parseInt(marcado.getAttribute('data-pc-preco-v'), 10), marcado.getAttribute('data-pc-titulo'));
      } else if (precoEl) {
        var btn = card.querySelector('[data-pc-comprar]');
        var cent = parseInt(precoEl.textContent.replace(/[^\d]/g, ''), 10);
        if (btn && cent) atualizaDose(card, cent, '1');
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    /* ── seletor de tamanho ── */
    var vb = e.target.closest('.pc-var');
    if (vb && !vb.disabled) {
      var card = vb.closest('[data-pc-card]');
      card.querySelectorAll('.pc-var').forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
      vb.setAttribute('aria-checked', 'true');

      var preco = parseInt(vb.getAttribute('data-pc-preco-v'), 10);
      var de = parseInt(vb.getAttribute('data-pc-de-v'), 10);
      var pEl = card.querySelector('[data-pc-preco]');
      var dEl = card.querySelector('[data-pc-de]');
      if (pEl) pEl.textContent = fmt(preco);
      var oEl = card.querySelector('[data-pc-off]');
      if (dEl) {
        if (de > preco) { dEl.textContent = fmt(de); dEl.hidden = false; }
        else { dEl.textContent = ''; dEl.hidden = true; }
      }
      /* O selo de desconto segue o preco cortado: some junto quando a
         variante escolhida nao tem preco de comparacao. */
      if (oEl) {
        var pct = de > preco ? Math.round((de - preco) * 100 / de) : 0;
        if (pct > 0) { oEl.textContent = '-' + pct + '%'; oEl.hidden = false; }
        else { oEl.textContent = ''; oEl.hidden = true; }
      }
      atualizaDose(card, preco, vb.getAttribute('data-pc-titulo'));

      var comprar = card.querySelector('[data-pc-comprar]');
      if (comprar) comprar.setAttribute('data-pc-comprar', vb.getAttribute('data-pc-var'));

      /* "Assinar" segue o tamanho escolhido. Se nao houver plano para aquele
         tamanho, o botao some — melhor do que assinar silenciosamente outra
         quantidade da que a pessoa marcou. */
      var assinar = card.querySelector('[data-pc-assinar]');
      if (assinar) {
        var sub = vb.getAttribute('data-pc-sub');
        var plano = vb.getAttribute('data-pc-plano');
        if (sub) {
          assinar.setAttribute('data-pc-assinar', sub);
          assinar.removeAttribute('data-pc-plano-usar');
          assinar.hidden = false;
        } else if (plano) {
          /* sem variante "/mensal": assina a propria variante com o plano nativo */
          assinar.setAttribute('data-pc-assinar', vb.getAttribute('data-pc-var'));
          assinar.setAttribute('data-pc-plano-usar', plano);
          assinar.hidden = false;
        } else { assinar.hidden = true; }
      }
      return;
    }

    /* ── comprar e assinar ── */
    var btn = e.target.closest('[data-pc-comprar], [data-pc-assinar]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var id = btn.getAttribute('data-pc-comprar') || btn.getAttribute('data-pc-assinar');
    var drawer = document.querySelector('cart-drawer');
    var rotulo = btn.querySelector('span') ? btn.querySelector('span').textContent : btn.textContent;
    btn.disabled = true;

    var fd = new FormData();
    fd.set('id', id);
    fd.set('quantity', 1);
    var planoUsar = btn.getAttribute('data-pc-plano-usar');
    if (planoUsar) fd.set('selling_plan', planoUsar);
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
    }

    fetch('/cart/add.js', {
      method: 'POST', body: fd, credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (resp.status) throw new Error(resp.description || 'erro');
        /* ja entrou no carrinho: se o redesenho falhar, recarrega em vez de
           deixar a tela mostrando o estado velho. */
        try {
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(resp);
            drawer.classList.remove('is-empty');
            if (typeof drawer.open === 'function') drawer.open();
          } else {
            window.location.href = '/cart';
          }
        } catch (err) { window.location.reload(); }
        btn.disabled = false;
      })
      .catch(function () { btn.disabled = false; });
  });
})();

/* ── P15 · A MARCA DE FRETE NO CARD ────────────────────────────────────────
   Decisao dos tres, e ela contraria a leitura literal do pedido de proposito.

   O pedido era marcar "toda variante que nao seja 1 unidade". Tres variantes nao
   atingem o limiar, entao marcar por POSICAO faria a pagina prometer frete que o
   checkout cobra. A marca sai da comparacao de PRECO, e tem dois estados — o
   pedido continua atendido, porque toda variante acima de 1 unidade fala de
   frete; o que muda e' que ela nunca mente.

   Por que o estado apagado NAO conta quanto falta: o `copy_gary` vetou, e o
   argumento e' a regra da casa — "nenhuma frase abre com nao tem". No estado
   padrao, que e' 1 pote, a primeira linha que a pessoa leria seria "voce nao tem
   o suficiente". O contador de falta vive no CARRINHO, onde ela ja decidiu
   comprar e esta montando o valor. */
(function () {
  if (window.__pcFreteLigado) return;
  window.__pcFreteLigado = true;

  function moeda(c) {
    return 'R$ ' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function pintar(card, precoCentavos) {
    var slot = card.querySelector('[data-pc-frete]');
    if (!slot) return;
    var alvo = slot.querySelector('[data-pc-frete-txt]');
    var limiar = parseInt(slot.getAttribute('data-pc-limiar') || '0', 10);
    if (!limiar || !precoCentavos) { alvo.textContent = ''; return; }

    var lim = moeda(limiar).replace(',00', '');
    var passa = precoCentavos >= limiar;
    var txt = slot.getAttribute(passa ? 'data-pc-frete-ok' : 'data-pc-frete-falta') || '';
    alvo.textContent = txt.replace('{limiar}', lim);
    slot.classList.toggle('pc-frete--ok', passa);
    slot.classList.toggle('pc-frete--falta', !passa);
  }

  function preco(card) {
    var m = card.querySelector('.pc-var[aria-checked="true"]');
    if (m) return parseInt(m.getAttribute('data-pc-preco-v'), 10);
    var p = card.querySelector('[data-pc-preco]');
    return p ? parseInt(p.textContent.replace(/[^\d]/g, ''), 10) : 0;
  }

  function iniciar() {
    document.querySelectorAll('[data-pc-card]').forEach(function (card) {
      pintar(card, preco(card));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();

  document.addEventListener('click', function (e) {
    var vb = e.target.closest && e.target.closest('.pc-var');
    if (!vb || vb.disabled) return;
    var card = vb.closest('[data-pc-card]');
    /* roda depois do handler do seletor, que ja marcou o aria-checked */
    setTimeout(function () { pintar(card, preco(card)); }, 0);
  });
})();
